function Footer() {
  return (
    <>
      <footer>
        <div className="container">
          <div className="footer-content">
            <ul className="footer-content__1">
              <li>
                <span>Location de</span> Véhicule
              </li>
              <li>
                Nous proposons un large choix de véhicules pour répondre à tous vos besoins.
                Nous avons la voiture idéale pour vous.
              </li>

              <li>
                <a href="tel:0664198759">
                  <i className="fa-solid fa-phone"></i> &nbsp; 06 64 19 87 59
                </a>
              </li>

              <li>
                <a
                  href="mailto: 
                carrental@gmail.com"
                >
                  <i className="fa-solid fa-envelope"></i>
                  &nbsp; kanorjean.christophe@gmail.com
                </a>
              </li>

              {/*<li>
                <a
                  style={{ fontSize: "14px" }}
                  target="_blank"
                  rel="noreferrer"
                  href="https://devrahuls.vercel.app/"
                >
                  Design with ❤️ by Rahul
                </a>
              </li>*/}
            </ul>

            <ul className="footer-content__2">
              <li>Voir aussi</li>
              <li>
                <a href="#home">Galerie</a>
              </li>
              <li>
                <a href="#home">Carrière</a>
              </li>
              <li>
                <a href="#home">Contact</a>
              </li>
              <li>
                <a href="#home">Blog</a>
              </li>
              <li>
                <a href="#home">Nos méthodes de travail</a>
              </li>
            </ul>

            <ul className="footer-content__2">
              <li>Horaire d'ouverture</li>
              <li>Lun - Dim: 9:00 - 21:00</li>
              {/*<li>Sat: 9:00AM - 19:00</li>*/}
              {/*<li>Sun: Closed</li>*/}
            </ul>

            <ul className="footer-content__2">
              <li>Inscription</li>
              <li>
                <p>Inscrivez votre adresse e-mail pour recevoir les dernières actualités et mises à jour.</p>
              </li>
              <li>
                <input type="email" placeholder="Adresse email"></input>
              </li>
              <li>
                <button className="submit-email">S'inscrire</button>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
